const Tournament = ({ tournament }) => {
    const bgColor = tournament.remaining_days <= 7 ? 'bg-red' : 'bg-orange'
    return <div className="flex w-[97%] md:w-[40%] justify-between mx-auto mt-3 md:mt-0 md:mb-4 bg-white rounded-full p-2">
        <div className="flex flex-col justify-around w-[70%] ps-5 pe-2">
            <p className="text-[15px]">{tournament.name}</p>
            <p className="bg-gray text-[13px] rounded-[12px] text-white text-center p-1">
                {`تعداد ${tournament.teams_count} تیم و ${tournament.users_count} نفر`}
            </p>
        </div>
        <div className={`flex ${bgColor} h-[110px] w-[110px] rounded-full flex-col justify-center`}>
            <span className="text-center text-[32px] text-white font-bold">{tournament.remaining_days}</span>
            <span className="text-center text-[16px] text-white ">روز مانده</span>
        </div>
    </div>
}

export default Tournament